<div class="response-project-document-uploader">
  <div
    class="response-project-document-uploader-card"
    [class.response-project-document-uploader-card--files-open]="fileRows.length > 0 && panelExpanded"
    [class.response-project-document-uploader-card--disabled]="contentDisabled"
  >
    @if (configMode && isImportingFilesPhase && isAddingToExisting) {
      <div class="response-project-document-uploader-config-add">
        <div class="response-project-document-uploader-config-add-header">
          <ng-container *ngTemplateOutlet="headerTitleTpl"></ng-container>
          <span class="response-project-document-uploader-panel-spacer"></span>
          <ng-container *ngTemplateOutlet="filesCountPillTpl; context: { count: newFiles.length }"></ng-container>
          <button
            type="button"
            class="response-project-document-uploader-config-add-cancel"
            (click)="onCancelConfigAdd()"
            [attr.aria-label]="'tenders.responses.documents.remove-all' | translate"
          >
            <i class="ph ph-x" aria-hidden="true"></i>
          </button>
        </div>

        <div class="response-project-document-uploader-list">
          @for (file of newFiles; track file.uid) {
            <ng-container *ngTemplateOutlet="fileRowTpl; context: { file: file, isNew: true }"></ng-container>
          }
        </div>

        <div class="response-project-document-uploader-config-add-actions">
          <ng-container *ngTemplateOutlet="addZoneTpl; context: { label: 'tenders.responses.documents.add-more-config' }"></ng-container>
          <button
            type="button"
            class="response-project-document-uploader-primary-btn"
            [disabled]="pendingProcess"
            (click)="onContinueClick()"
          >
            {{ 'tenders.responses.documents.config-add-submit' | translate }}
          </button>
        </div>
      </div>
    } @else if (fileRows.length === 0 && panelExpanded && ignoredFiles.length <= 1 && !configMode) {
      <div class="response-project-document-uploader-card-header">
        <ng-container *ngTemplateOutlet="headerTitleTpl"></ng-container>
      </div>

      <div class="response-project-document-uploader-inner response-project-document-uploader-inner--empty">
        @if (ignoredFiles.length === 1) {
          <div class="response-project-document-uploader-single-file-error">
            <i class="ph ph-warning" aria-hidden="true"></i>
            {{ ignoredFiles[0].reason | translate }}
          </div>
        }
        <ng-container *ngTemplateOutlet="dropzoneTpl"></ng-container>
      </div>
    } @else {
      <div class="response-project-document-uploader-panel-head">
        <button
          type="button"
          class="response-project-document-uploader-panel-toggle"
          (click)="togglePanelExpanded()"
          [attr.aria-expanded]="panelExpanded"
        >
          <ng-container *ngTemplateOutlet="headerTitleTpl"></ng-container>
          <span class="response-project-document-uploader-panel-spacer"></span>
          @if (fileRows.length > 0) {
            @if (processingStep === DocumentProcessingStepEnum.UPLOADING && uploadBatchTotal > 0) {
              <ex-pill variant="info" [showSpinner]="true">
                {{ 'tenders.responses.documents.upload-loading' | translate: { completed: uploadBatchCompleted, total: uploadBatchTotal } }}
              </ex-pill>
            } @else if (processingStep === DocumentProcessingStepEnum.CATEGORIZING) {
              <ex-pill variant="warning" [showSpinner]="true">
                {{
                  'tenders.responses.documents.categorization-loading'
                    | translate: { completed: categorizationCompleted, total: categorizationTotal }
                }}
              </ex-pill>
            } @else if (isImportingFilesPhase) {
              <ng-container *ngTemplateOutlet="filesCountPillTpl; context: { count: fileRows.length }"></ng-container>
            } @else if (continueSubmitted && processingStep === null) {
              @if (uncategorizedCount > 0) {
                <ex-pill variant="warning" phosphorIcon="warning">
                  {{ 'tenders.responses.documents.to-categorize-count' | translate: { count: uncategorizedCount } }}
                </ex-pill>
              } @else {
                <ex-pill variant="success">
                  @if (addedCount === 1) {
                    {{ 'tenders.responses.documents.added-count-one' | translate: { count: addedCount } }}
                  } @else {
                    {{ 'tenders.responses.documents.added-count-many' | translate: { count: addedCount } }}
                  }
                </ex-pill>
              }
            }
          }

          @if (continueSubmitted || configMode) {
            <i
              class="ph ph-caret-down response-project-document-uploader-panel-caret"
              [class.response-project-document-uploader-panel-caret--expanded]="panelExpanded"
              aria-hidden="true"
            ></i>
          }
        </button>
      </div>

      <div
        class="response-project-document-uploader-expandable"
        [class.response-project-document-uploader-expandable--collapsed]="!panelExpanded"
      >
        @if (fileRows.length === 0 && ignoredFiles.length > 0) {
          <div class="response-project-document-uploader-inner response-project-document-uploader-inner--with-files">
            <app-ignored-files-notice [files]="ignoredFiles" />
            <div class="response-project-document-uploader-actions">
              <ng-container *ngTemplateOutlet="addZoneTpl; context: { label: 'tenders.responses.documents.add-more' }"></ng-container>
            </div>
          </div>
        } @else if (fileRows.length === 0) {
          <div class="response-project-document-uploader-inner response-project-document-uploader-inner--empty">
            <ng-container *ngTemplateOutlet="dropzoneTpl"></ng-container>
          </div>
        } @else {
          @if (
            (processingStep === DocumentProcessingStepEnum.UPLOADING && uploadBatchTotal > 0) ||
            processingStep === DocumentProcessingStepEnum.CATEGORIZING
          ) {
            <div
              class="response-project-document-uploader-batch-bar"
              role="progressbar"
              [attr.aria-valuemin]="0"
              [attr.aria-valuemax]="100"
              [attr.aria-valuenow]="
                processingStep === DocumentProcessingStepEnum.UPLOADING
                  ? batchProgressPercent
                  : (categorizationCompleted / categorizationTotal) * 100
              "
            >
              <div
                class="response-project-document-uploader-batch-bar__fill"
                [class.response-project-document-uploader-batch-bar__fill--warning]="
                  processingStep === DocumentProcessingStepEnum.CATEGORIZING
                "
                [style.width.%]="
                  processingStep === DocumentProcessingStepEnum.UPLOADING
                    ? batchProgressPercent
                    : (categorizationCompleted / categorizationTotal) * 100
                "
              ></div>
            </div>
          }

          <div class="response-project-document-uploader-inner response-project-document-uploader-inner--with-files">
            <app-ignored-files-notice [files]="ignoredFiles" />
            @if (uncategorizedCount > 0 && processingStep === null) {
              <app-uncategorized-notice [count]="uncategorizedCount" />
            }
            @if (dedupEnabled && duplicates.length) {
              <div class="response-project-document-uploader-dedup">
                <app-duplicate-resolver [surface]="dedupSurface" [items]="duplicates" (resolve)="onDuplicateResolve($event)" />
              </div>
            }
            <div #listContainer class="response-project-document-uploader-list" cdkScrollable>
              @for (file of sortedFileRows; track file.uid) {
                <ng-container *ngTemplateOutlet="fileRowTpl; context: { file: file, isNew: false }"></ng-container>
              }
            </div>

            @if (isImportingFilesPhase) {
              <div class="response-project-document-uploader-actions">
                <ng-container
                  *ngTemplateOutlet="
                    addZoneTpl;
                    context: {
                      label: configMode ? 'tenders.responses.documents.add-more-config' : 'tenders.responses.documents.add-more',
                    }
                  "
                ></ng-container>

                <button
                  class="response-project-document-uploader-primary-btn"
                  type="button"
                  [disabled]="fileRows.length === 0 || pendingProcess"
                  (click)="onContinueClick()"
                >
                  {{ (configMode ? 'tenders.responses.documents.config-add-submit' : 'tenders.responses.documents.continue') | translate }}
                </button>
              </div>
            }
            @if (configMode && !isImportingFilesPhase && processingStep === null) {
              <button
                type="button"
                class="response-project-document-uploader-compact-add"
                [class.response-project-document-uploader-compact-add--dragging]="isDragging"
                (click)="triggerFileInput(configAddInput)"
                (dragenter)="onDragEnter($event)"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
              >
                <input
                  #configAddInput
                  type="file"
                  multiple
                  [attr.accept]="accept"
                  (change)="onFileInputChange($event)"
                  (click)="$event.stopPropagation()"
                />
                <i class="ph ph-plus" aria-hidden="true"></i>
                {{ 'tenders.responses.documents.add-more-config' | translate }}
              </button>
            }
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template #fileRowTpl let-file="file" let-isNew="isNew">
  <div
    class="file"
    [class.file--extracting]="!isNew && file.processingStep === DocumentProcessingStepEnum.EXTRACTING"
    [class.file--categorizing]="!isNew && file.processingStep === DocumentProcessingStepEnum.CATEGORIZING"
    [class.file--categorized]="!isNew && file.justCategorized"
    [attr.data-file-id]="file.uid"
  >
    <div class="file-row">
      <app-document-identity
        class="file-identity"
        [name]="file.name"
        [subtypeName]="subtypeNameOf(file)"
        [fileSize]="file.size"
        [showUncategorized]="!isNew && file.processingStep === DocumentProcessingStepEnum.UNCATEGORIZED"
        [processingStep]="file.processingStep ?? null"
        [uploadProgress]="file.uploadProgress ?? null"
        [isArchive]="!isNew && isZipFile(file)"
        [justCategorized]="!isNew && !!file.justCategorized"
      />
      <div class="file-right">
        @if (isNew) {
          <button
            type="button"
            class="file-remove-btn"
            (click)="onDelete(file)"
            [attr.aria-label]="'tenders.responses.documents.delete-file' | translate"
          >
            <i class="ph ph-x" aria-hidden="true"></i>
          </button>
        } @else {
          <ng-container *ngTemplateOutlet="fileActionsTpl; context: { $implicit: file }"></ng-container>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #filesCountPillTpl let-count="count">
  <ex-pill variant="neutral">
    @if (count === 1) {
      {{ 'tenders.responses.documents.imported-files-count-one' | translate: { count: count } }}
    } @else {
      {{ 'tenders.responses.documents.imported-files-count-many' | translate: { count: count } }}
    }
  </ex-pill>
</ng-template>

<ng-template #addZoneTpl let-label="label">
  <app-document-import-zone
    class="response-project-document-uploader-add-zone-brick"
    variant="compact"
    [accept]="accept"
    [addLabel]="label"
    (filesSelected)="onZoneFilesSelected($event)"
    (filesRejected)="onZoneFilesRejected($event)"
  />
</ng-template>

<ng-template #dropzoneTpl>
  <div
    class="response-project-document-uploader-dropzone"
    [class.response-project-document-uploader-dropzone--dragging]="isDragging"
    (click)="triggerFileInput(dropzoneInput)"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <input
      #dropzoneInput
      type="file"
      multiple
      [attr.accept]="accept"
      (change)="onFileInputChange($event)"
      (click)="$event.stopPropagation()"
    />

    @if (isDragging) {
      <div class="response-project-document-uploader-dropzone-overlay">
        <div class="response-project-document-uploader-dropzone-drag-icon">
          <i class="ph ph-upload-simple response-project-document-uploader-dropzone-pulse"></i>
        </div>
        <h3>{{ 'tenders.responses.documents.dropzone-dragging' | translate }}</h3>
        <p>{{ dragFormatsText || ('tenders.responses.documents.zone-formats' | translate) }}</p>
      </div>
    }

    <div class="response-project-document-uploader-dropzone-icon"><i class="ph ph-upload-simple"></i></div>
    <h3>{{ mainTitle }}</h3>
    @if (scope === 'dce') {
      <p class="response-project-document-uploader-dropzone-recommendation">
        <span class="response-project-document-uploader-dropzone-recommendation-muted">{{
          'tenders.responses.documents.recommended-dce-lead' | translate
        }}</span>
        {{ ' ' }}
        <strong>{{ 'tenders.responses.documents.recommended-dce-cctp' | translate }}</strong>
        {{ ' ' }}
        <span class="response-project-document-uploader-dropzone-recommendation-muted">{{
          'tenders.responses.documents.recommended-dce-join' | translate
        }}</span>
        {{ ' ' }}
        <strong>{{ 'tenders.responses.documents.recommended-dce-rc' | translate }}</strong
        >{{ 'tenders.responses.documents.recommended-dce-suffix' | translate }}
      </p>
    }
    @if (emptyStateSubhint) {
      <p class="response-project-document-uploader-dropzone-subhint">{{ emptyStateSubhint }}</p>
    }
    @if (scope !== 'internal_doc') {
      <div class="response-project-document-uploader-hints" (click)="$event.stopPropagation()">
        <span class="response-project-document-uploader-hint response-project-document-uploader-hint--zip">
          <i class="ph ph-archive" aria-hidden="true"></i>
          {{ 'tenders.responses.documents.hint-zip' | translate }}
        </span>
        @for (key of dropzoneFormatHintKeys; track key; let isLastFormat = $last) {
          <span class="response-project-document-uploader-hint" [class.response-project-document-uploader-hint--muted]="isLastFormat">
            {{ key | translate }}
          </span>
        }
      </div>
    } @else if (scope === 'internal_doc') {
      <div class="response-project-document-uploader-hints" (click)="$event.stopPropagation()">
        <span class="response-project-document-uploader-hint response-project-document-uploader-hint--featured">
          {{ 'tenders.responses.documents.hint-internal-memoire' | translate }}
        </span>
        <span class="response-project-document-uploader-hint">{{ 'tenders.responses.documents.hint-internal-plaquette' | translate }}</span>
        <span class="response-project-document-uploader-hint">{{ 'tenders.responses.documents.hint-internal-cv' | translate }}</span>
        <span class="response-project-document-uploader-hint">{{ 'tenders.responses.documents.hint-internal-reference' | translate }}</span>
        <span class="response-project-document-uploader-hint response-project-document-uploader-hint--muted">{{
          'tenders.responses.documents.hint-max-size' | translate
        }}</span>
      </div>
    }
    <button
      type="button"
      class="response-project-document-uploader-dropzone-btn"
      (click)="triggerFileInput(dropzoneInput); $event.stopPropagation()"
    >
      {{ 'tenders.responses.documents.browse' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #headerTitleTpl>
  <div class="response-project-document-uploader-card-header-title">
    <i class="ph ph-folder"></i>
    <p>{{ title }}</p>
    @if (titleBadgeKind === 'recommended') {
      <ex-pill variant="success">{{ 'tenders.responses.documents.recommended' | translate }}</ex-pill>
    } @else if (titleBadgeKind === 'required') {
      <ex-pill variant="info">{{ 'tenders.responses.documents.required' | translate }}</ex-pill>
    }
  </div>
</ng-template>

<ng-template #fileActionsTpl let-file>
  @if (
    (file.processingStep === DocumentProcessingStepEnum.CATEGORIZED || file.processingStep === DocumentProcessingStepEnum.UNCATEGORIZED) &&
    subtypeOptions.length
  ) {
    <app-category-selector
      [options]="subtypeOptions"
      [value]="getSubTypeDisplayName(file) || null"
      [uncategorized]="file.processingStep === DocumentProcessingStepEnum.UNCATEGORIZED && !file.subtype"
      (optionSelected)="selectSubtype(file, $event)"
      (customSelected)="selectCustomSubtype(file, $event)"
    />
  }
  @if (file.processingStep !== DocumentProcessingStepEnum.UPLOADING && processingStep === null) {
    <button
      type="button"
      class="file-remove-btn"
      (click)="onDelete(file)"
      [attr.aria-label]="'tenders.responses.documents.delete-file' | translate"
    >
      <i class="ph ph-x" aria-hidden="true"></i>
    </button>
  }
</ng-template>
